export function computeHeight(container: HTMLElement, height: number | string): number {
	return typeof height === 'number' ? height : container.clientHeight;
}
